import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';
import Country from './Country';

export default class Office extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get id() {
    return this.system.id;
  }

  get country() {
    return get(this, '_kraj.value[0]', new Country());
  }

  get location() {
    return get(this, '_lokalizacja.value[0].name', '');
  }
  get address() {
    return get(this, '_adres.value', '');
  }

  get email() {
    return get(this, '_email.value', '');
  }

  get phoneNumber() {
    return get(this, '_numer_telefonu.value', '');
  }

  get latitude() {
    return get(this, '_szerokosc_geograficzna.value', '');
  }

  get longitude() {
    return get(this, '_dlugosc_geograficzna.value', '');
  }

  get contactPerson() {
    return get(this, '_osoba_kontaktowa.value[0]');
  }
}



// WEBPACK FOOTER //
// ./src/models/Office.js